<h1 class="title">Documents</h1>

<button class="close-button" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>

<div class="doc-items">
  @for (tab of agreementTabs; track tab; let i = $index) {
    <div class="doc-item">
      @if (!documentSigned[tab.value]) {
        <div class="doc-number" [class.active]="selectedTab === tab.value">{{ i + 1 }}</div>
      }
      @if (documentSigned[tab.value]) {
        <rkt-icon class="doc-signed" name="check"></rkt-icon>
      }
      {{ tab.label | titlecase }}
    </div>
  }
</div>

<div class="scroll-wrapper">
  @if (selectedTab && document) {
    <ngx-extended-pdf-viewer
      [src]="document"
      [showBorders]="false"
      [showToolbar]="false"
      [textLayer]="false"
      backgroundColor="#F7F7F7"
      [authorization]="true"
      (pageChange)="onPageChange($event)"
      (pagesLoaded)="onPagesLoaded($event)"
    ></ngx-extended-pdf-viewer>
  }
</div>

<div class="buttons">
  <button rktButton type="button" btnType="tertiary" (click)="prevTab()" title="Back">Back</button>
  <button
    rktButton
    type="submit"
    (click)="nextTab()"
    [disabled]="!selectedTab || !isScrolledToTheEnd[selectedTab]"
    title="Agree and continue"
  >
    Agree and continue
  </button>
</div>
